import { FC } from 'react';
import './ServiceOffered.scss';
import { Box, VStack, Heading, Text, Image, Flex, Container } from '@chakra-ui/react';
import WhatsAppButton from '../../components/WhatsAppButton/WhatsAppButton';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

const categories = [
    {
        title: 'Nossa Senhora Aparecida',
        bgColor: 'color.50',
        products: [
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida.jpg'),
                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em pérolas e com acabamento em strass. Com 25cm de altura.',
                price: 150,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-1.jpg'),
                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em pérolas e com acabamento em strass. Com 25cm de altura.',
                price: 190,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-2-1.jpg'),
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-2-2.jpg'),
                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Tecido Chita e com acabamento em Pérolas e strass. Com 25cm de altura.',
                price: 160,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-3.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em pérolas e com acabamento em strass. Com 30cm de altura.',
                price: 190,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-4.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em pérolas e com acabamento em strass. Com 25cm de altura.',
                price: 150,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-5.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Tecido Linho e com acabamento  em flores, pérolas e strass. Com 30cm de altura.',
                price: 190,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-6.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Flores de Guiper e com acabamento em  Pérolas e Strass. Com 25cm de altura.',
                price: 160,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-7.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Pérolas e com acabamento em Pérolas. Com 20cm de altura.',
                price: 90,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-8.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Pérolas e com acabamento em Pérolas. Com 25cm de altura.',
                price: 150,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-9.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Flores de Guiper e com acabamento em Strass. Com 25cm de altura.',
                price: 150,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-10.jpg'),

                ],
                name: 'Nossa Senhora com Altar',
                description: 'Altar MDF, peça em material de gesso, revestida em Tecido Linho e com acabamento em Flores, pérolas e strass. Com 25cm de altura.',
                price: 150,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-11.jpg'),

                ],
                name: 'Nossa Senhora Aparecida Baby',
                description: 'Peça em material de gesso, revestida em Tecido Linho e com acabamento em Flores e pérolas. Com 14cm de altura.',
                price: 65,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-12.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Flores de Guiper e com acabamento em Pérolas e Strass. Com 25cm de altura.',
                price: 160,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-13.jpg'),

                ],
                name: 'Nossa Senhora Aparecida Baby',
                description: 'Peça em material de gesso, revestida em Pérolas e com acabamento em Strass. Com 14cm de altura.',
                price: 65,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-14.jpg'),

                ],
                name: 'Nossa Senhora Aparecida Baby',
                description: 'Peça em material de gesso, revestida em Pérolas e com acabamento em Strass. Com 14cm de altura.',
                price: 65,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-15.jpg'),

                ],
                name: 'Nossa Senhora Aparecida Baby',
                description: 'Peça em material de gesso, revestida em Pérolas e com acabamento em Strass. Com 14cm de altura.',
                price: 65,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-16.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Tecido Linho e com acabamento em Flores, pérolas e strass. Com 25cm de altura.',
                price: 160,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-17.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, feita na Decoupagem e com acabamento em pérolas e strass. Com 25cm de altura.',
                price: 150,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-18.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Pérolas e com acabamento em strass. Com 30cm de altura.',
                price: 190,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-19.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Pérolas e com acabamento em strass. Com 40cm de altura.',
                price: 230,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-20.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Pérolas e com acabamento em strass. Com 20cm de altura.',
                price: 110,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-21.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Pérolas e strass. Com 20cm de altura.',
                price: 130,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-22.jpg'),

                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em Tecido Linho e acabamento em Flores, pérolas e strass. Com 25cm de altura.',
                price: 160,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Fatima-23.jpg'),

                ],
                name: 'Nossa Senhora de Fátima',
                description: 'Peça em material de gesso, revestida em Pérolas. Com 20cm de altura.',
                price: 90,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Fatima-24.jpg'),

                ],
                name: 'Nossa Senhora de Fátima',
                description: 'Peça em material de gesso, feita na Decoupagem e acabamento em Pérolas e Strass. Com 20cm de altura.',
                price: 90,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Fatima-25.jpg'),

                ],
                name: 'Nossa Senhora de Fátima',
                description: 'Peça em material de gesso, revestida em pérolas e acabamento em Strass. Com 20cm de altura.',
                price: 90,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Fatima-26.jpg'),
                    require('../../assets/img/product/Nossa-Senhora-Fatima-26-1.jpg'),
                ],
                name: 'Nossa Senhora de Fátima',
                description: 'Peça em material de gesso, revestida em pérolas e acabamento em Strass. Acompanha Coroa de Metal. Com 30cm de altura.',
                price: 180,
                installments: 3
            },
            {
                img: [
                    require('../../assets/img/product/Nossa-Senhora-Aparecida-27.jpg'),
                ],
                name: 'Nossa Senhora Aparecida',
                description: 'Peça em material de gesso, revestida em pérolas e acabamento em Strass. Com 40cm de altura.',
                price: 230,
                installments: 3
            },
        ],
    },
];

const ServiceOffered: FC = () => {
    return (
        <div className="ServiceOffered" data-testid="ServiceOffered" >
            <Flex direction="column" align="center" justify="center" w="100%">
                {categories.map((category, catIndex) => (
                    <Box key={catIndex} bg={category.bgColor} py={10} w="100%">
                        <Container maxW="1200px" px={{ base: 4, md: 0 }}>
                            <Heading
                                as="h2"
                                textTransform="uppercase"
                                fontSize={{ base: '2xl', md: '4xl' }}
                                textAlign="center"
                                color="color.500"
                                mb={12}
                            >
                                {category.title}
                            </Heading>

                            <Box
                                display="grid"
                                gridTemplateColumns={{ base: '1fr', md: '1fr 1fr', lg: 'repeat(3, 1fr)' }}
                                gap={10}
                            >
                                {category.products.map((product, index) => (
                                    <Box
                                        key={index}
                                        bg="white"
                                        borderRadius="2xl"
                                        boxShadow="lg"
                                        overflow="hidden"
                                        _hover={{ boxShadow: '2xl', transform: 'scale(1.02)', transition: '0.3s' }}
                                    >
                                        <Box h="420px" overflow="hidden">
                                            {product.img.length > 1 ? (
                                                <Swiper
                                                    modules={[Autoplay, Pagination]}
                                                    autoplay={{ delay: 3000 }}
                                                    loop={true}
                                                    pagination={{ clickable: true }}
                                                    style={{ width: "100%", height: "100%" }}
                                                >
                                                    {product.img.map((imageSrc, i) => (
                                                        <SwiperSlide key={i}>
                                                            <Image
                                                                src={imageSrc}
                                                                alt={`${product.name}-${i}`}
                                                                objectFit="cover"
                                                                w="100%"
                                                                h="420px"
                                                            />
                                                        </SwiperSlide>
                                                    ))}
                                                </Swiper>
                                            ) : (
                                                <Image
                                                    src={product.img[0]}
                                                    alt={product.name}
                                                    objectFit="cover"
                                                    w="100%"
                                                    h="420px"
                                                />
                                            )}
                                        </Box>

                                        <VStack spacing={3} align="flex-start" p={6}>
                                            <Heading as="h3" size="md" color="color.500">
                                                {product.name}
                                            </Heading>

                                            <Text fontSize="sm" color="gray.600" noOfLines={2}>
                                                {product.description}
                                            </Text>

                                            {/* Box contendo preço e parcela com botão */}
                                            <Flex justify="space-between" align="center" w="100%" mt={2}>
                                                <Box>
                                                    {/* Preço */}
                                                    <Text fontWeight="bold" fontSize="lg" color="gray.700">
                                                        R$ {product.price.toFixed(2).replace('.', ',')}
                                                    </Text>

                                                    {/* Parcela */}
                                                    {product.installments && (
                                                        <Text fontSize="sm" color="gray.500">
                                                            ou em até {product.installments}x de R$ {(product.price / product.installments).toFixed(2).replace('.', ',')}
                                                        </Text>
                                                    )}
                                                </Box>

                                                {/* Botão alinhado à direita da parcela */}
                                                <WhatsAppButton title="Solicitar" size="sm" />
                                            </Flex>
                                        </VStack>
                                    </Box>
                                ))}
                            </Box>
                        </Container>
                    </Box>
                ))}
            </Flex>
        </div>

    );
};

export default ServiceOffered;
